<template>
  <div class="fill-height">


    <v-card class="fill-height">

      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
          مدیران ساختمان
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="2"
                 v-if="can('newManager')" class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>fa fa-plus</v-icon>
            </v-btn>
            <create-manager  :model-items="data"  :dialogStatus.sync="showDialog"/>
          </v-col>
          <v-col cols="12"
                 sm="4"
                 class="d-inline-flex"
          >
            <v-text-field
                outlined
                dense
                placeholder="نام کاربری،نام"
                v-model="searchvalue"


            />
            <v-btn  fab small color="primary" @click="search" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col cols="12"
                 sm="12" md="6" class="d-inline-block">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>


        </v-row>
        <v-spacer/>
        <b-table
            v-if="can('managerList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
            responsive striped
        >
          <template #cell(actions)="row">
            <v-btn depressed small v-if="can('editManager')" color="primary" @click="forEdit(row.item)" class="mr-1 ">
              ویرایش
            </v-btn>
            <v-btn depressed class="mr-1" v-if="can('deleteManager')" small color="error" @click="remove(row.item)">
              حذف
            </v-btn>
          </template>
        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CreateManager from './PageEdit'
import Manager_se from "./Manager_se";
import {mapMutations} from "vuex";

export default {
  name: 'Manager',
  components: {
    CreateManager
  },
  data() {
    return {
      searchvalue: '',
      modelId: '',
      data: {},
      showDialog: false,
      modelAtributes: {},
      dataItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'user.userName', label: 'نام کاربری', sortable: true, sortDirection: 'desc'},
        {key: 'user.person.fullName', label: 'نام', sortable: true, sortDirection: 'desc'},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('Manager', () => {
      this.fillDataItems()
    })

  },

  methods: {
    close(){
      this.searchvalue=""
      this.$root.$emit('Manager')
      this.$router.push('/home')
    },

    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),

    fetch() {
      Manager_se.getById(this.modelId).then(response => {
        this.data = response.data
      })
      this.showDialog = true;
    },
    forEdit: function (e) {
      this.modelId = e.id;
      this.fetch()
    },

    forNew: function () {
      this.data = {};
      this.modelId = '';
      this.fetch()
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              Manager_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },

    fillDataItems() {
      this.modelAtributes = (Manager_se.getPage(this.searchvalue,this.skip - 1, this.take).then(response => {
        this.modelAtributes = response.data
        this.paging = this.modelAtributes.page
        this.dataItems = this.modelAtributes.managerList

      }));
    },

    search(){
      this.skip=0
      this.take=10
      this.fillDataItems()
    }
  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
